import { StyledButton } from "./styles";
import { ButtonProps } from "../../types";
import React from "react";

export const CancelButton = ({
  width,
  height,
  type,
  background,
  float,
  children,
  color,
  fontSize,
  disabled,
  onClick,
}: ButtonProps) => (
  <StyledButton type={type} fontSize={fontSize} color={color} width={width} height={height} background={background} float={float} disabled={disabled} onClick={onClick}>
    {children}
  </StyledButton>
);
